// mapConfig.js - All configuration constants

export const POSITION_HISTORY_SIZE = 25;
export const DIRECTION_CHECK_THRESHOLD = 4;
export const MOVEMENT_THRESHOLD = 10; // meters
export const TERMINAL_THRESHOLD = 20; // meters near terminal
export const STOP_DETAILS_FETCH_INTERVAL = 50000; // 50 seconds
export const RECONNECT_INTERVAL = 5000;
export const MAX_RECONNECT_ATTEMPTS = 25;
export const ANIMATION_INTERVAL = 200; // Fixed interval for smooth movement
export const SMOOTHING_FACTOR = 0.1; // For position smoothing
export const SPEED_MULTIPLIER = 0.1;
export const MIN_MOVEMENT_THRESHOLD = 10; // meters
export const MAX_HISTORY_LENGTH = 5;
export const MAX_SNAP_DISTANCE = 50;
export const TERMINAL_RADIUS = 70;

export const DEFAULT_DEVIATION_DISTANCE_METERS = 200;
// Drawn path starts when the vehicle leaves the planned line, not at the deviation setting.
export const ROUTE_LEAVE_DRAW_METERS = 15;
export const OFF_ROUTE_CONFIRMATION_POINTS = 3;
export const ON_ROUTE_CONFIRMATION_POINTS = 3;
export const ROUTE_DEVIATION_HYSTERESIS_METERS = 10;
export const ACTUAL_PATH_COLOR = "#FF6B00";
export const ACTUAL_PATH_STROKE_WEIGHT = 5;
export const ACTUAL_PATH_Z_INDEX = 20;
export const ACTUAL_PATH_MAX_POINTS = 1500;
export const ACTUAL_PATH_MAX_SPEED_KMH = 180;

export const libraries = ["places", "directions"];

export const getVehicleIcon = (status, vehicle_color, heading, pathDirection) => {
  heading = Math.floor(heading) || 0;
  const color = vehicle_color || "green";
  const finalHeading = heading + 90;
  
  // Import this function from vehicleIcons.js
  const { getRightToLeftBusIcon } = require("../../../pages/stops/vehicleIcons.js");
  const rotatedSVG = getRightToLeftBusIcon(color, finalHeading).trim();
  const encodedSVG = encodeURIComponent(rotatedSVG);

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodedSVG}`,
    scaledSize: new window.google.maps.Size(45, 44),
    anchor: new window.google.maps.Point(22, 22),
  };
};